module.exports = __webpack_public_path__ + "static/media/p1_b_01.b78c060f.jpg";